import { Component, OnInit,Input,Output,EventEmitter,ViewChild,ChangeDetectorRef } from '@angular/core';
import{SubjectManagmentService} from '../../../Services/subject-management/subject-management.service';
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup } from '@angular/forms';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { VRemoveResource } from 'src/app/Validators/Validators';
import { SubjectResourceAssign } from 'src/app/Models/subject-resource-assignment';
import { AppOfflineStore } from '../../../app.offlineService';

@Component({
  selector: 'app-subject-remove-resource-assignment',
  templateUrl: './subject-remove-resource-assignment.component.html',
  styleUrls: ['./subject-remove-resource-assignment.component.css']
})
    export class SubjectRemoveResourceAssignmentComponent implements OnInit {
  @Input() RemoveResourcePopup:boolean;
  @Input() RedirectRemoveResourceId:Number;
  @Input() RemoveResouceclosepopupflag:boolean;
  @Output() cancelRemoveResourcePopup:EventEmitter<any> =new EventEmitter<any>();
  @Output() cancelpopup:EventEmitter<any> =new EventEmitter<any>();
  @Output() DisableButton1:EventEmitter<any> =new EventEmitter<any>();
  
  RemoveResourceAssignform:FormGroup;
  InsertUpdateSubjectResource: SubjectResourceAssign;
  todayDate:Date = new Date();
  Disable:boolean;
 
  constructor(private cdr: ChangeDetectorRef,private appserv:AppOfflineStore,public pipe:DatePipe,public service:SubjectManagmentService,private toastr: ToastrService,private fb: FormBuilder) { 
   
    this.todayDate=new Date(this.todayDate.setDate(this.todayDate.getDate() - 1));
    this.Disable=!this.Disable;
  }
  InitializeForm(){
    this.RemoveResourceAssignform = this.fb.group({
      Subject_Name:[],
      PowerUserRoleTypeCode:[],
      PowerUserId:[],
      StartDate:[], 
      EndDate:["",VRemoveResource],  
      TerminationCommentText:[],
      DelegatedToPowerUserId:[],
      Termination_Reason_Selected_Ind:[]
    });
  }

  ngOnInit() {
    this.InitializeForm();
    this.getCode();
    this.getSubjectRoleAssignmentByID();
    this.getSubjectTerminationReason();
    this.Terminationcount();
    //this.cdr.detectChanges();
    
    

  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }


  getcodes:any;
  getCode()
  {
    this.service.GetCode({'Tablename':"POWER_USER_ROLE_TYPE"}).subscribe((i:any)=>{
      this.getcodes=i;
    // }).catch((e:any)=>{
    //   this.getcodes=null;
    // });
  }, (error:any) => { console.log(error) }
  );
  }

  error:any={isError:false,errorMessage:''};
  compareEndDates(){
    this.Editformvalidation();
    if(new Date(this.RemoveResourceAssignform.controls['EndDate'].value)<new Date(this.RemoveResourceAssignform.controls['StartDate'].value)){
       this.error={isError:true,errorMessage:'End Date cant before start date'};
    }
    else{
      this.error={isError:false,errorMessage:''};
    }
   }

   error1:any={isError:false,errorMessage:''};
   check:boolean=false;
   checkboxvalidation(){
    this.check=false;
    for (let item of this.ResponseReason) {
      if(item.Termination_Reason_Selected_Ind=="Y")
      {
        this.check=true;
        break;
      }
    }
    if(this.check)
        this.error1={isError:false,errorMessage:''};
    else
       this.error1={isError:true,errorMessage:'Select at least one Termination Reason'};
 }
 subjectdetails:any;
  GetSubjectByID(data:any){
    this.service.getsubjectById({'CurrentNodeSubjectID':Number(data)}).subscribe((i:any)=>{
      this.subjectdetails=i;
      this.RemoveResourceAssignform.controls['Subject_Name'].setValue(this.subjectdetails.Subject_Name);
    // }).catch((e:any)=>{
    //   this.subjectdetails=null;
    // });
  }, (error:any) => { console.log(error) }
  );

  }
 

  ResponseSubjectRoleId:any;
  ngvalue:any;
  SubjectRoleID:any;
  getSubjectRoleAssignmentByID()
  {
    this.service.GetSubjectRoleAssignmentByID({'Subject_Role_Assignment_ID':Number(this.RedirectRemoveResourceId)}).subscribe((i:any)=>{
      this.ResponseSubjectRoleId=i;
      this.SubjectRoleID=this.ResponseSubjectRoleId.SubjectExistsInd;
      this.getResourceName(this.SubjectRoleID.Power_User_Role_Type_Code);
      this.RemoveResourceAssignform.controls['PowerUserRoleTypeCode'].setValue(this.SubjectRoleID.Power_User_Role_Type_Code);
      this.RemoveResourceAssignform.controls['PowerUserId'].setValue(this.SubjectRoleID.Power_User_Id);
      this.RemoveResourceAssignform.controls['StartDate'].setValue(this.SubjectRoleID.Start_Date);
      this.RemoveResourceAssignform.controls['TerminationCommentText'].setValue(this.SubjectRoleID.TerminationCommentText);
      this.GetSubjectByID(this.SubjectRoleID.Subject_Id);
      
    // }).catch((e:any)=>{
    //   this.SubjectRoleID=null;
    // });
  }, (error:any) => { console.log(error) }
  );
  }

  ResponseReason:any;
  getSubjectTerminationReason(){
    var GetReason = { 
      PowerUserRoleAssignmentID:this.RedirectRemoveResourceId, 
      IncludeReasonNotSelectedInd:"Y" 
   }; 
    this.service.GetSubjectRoleTerminationReason(GetReason).subscribe((i:any)=>{
      this.ResponseReason=i;
     
    }, (error:any) => { console.log(error) }
    );
  }

  ResourceName:any
  getresourcedetails:any
  ngselect:any;
  selectrolecode:any
  getResourceName(index:any)
  {
  
    this.ResourceName = {
      LanguageTypeCode:this.appserv.MotherTongueLanguage,
      SubjectID:this.SubjectRoleID.Subject_Id,
      PowerUserRoleTypeCode:this.SubjectRoleID.Power_User_Role_Type_Code,
      PowerUserRoleStatusTypeCode:null,
      ExcludedPowerUserID:null,
      translatedInd:'N'
    }
    this.service.GetPowerUserByRole(this.ResourceName).subscribe((i:any)=>{
      this.getresourcedetails=i;
    // }).catch((e:any)=>{
    //   this.SubjectRoleID=null;
    // });
  }, (error:any) => { console.log(error) }
  );
  }
  
  removeresourcemodal:boolean
  cancel()
  {
    this.cancelRemoveResourcePopup.emit(this.removeresourcemodal);
  }

  Removeresponse:any;
  TerminationReasons:any;
  removesubmit:boolean=false;
  Save()
  {
    this.checkboxvalidation();
    if(!this.error1.isError&&!this.error.isError){
      this.removesubmit=true;
    if(this.RemoveResourceAssignform.valid){
      this.InsertUpdateSubjectResource = this.RemoveResourceAssignform.value;
      this.InsertUpdateSubjectResource.SubjectId=this.SubjectRoleID.Subject_Id;
      this.InsertUpdateSubjectResource.StartDate=this.pipe.transform(this.InsertUpdateSubjectResource.StartDate,'MM/dd/yyyy');
      this.InsertUpdateSubjectResource.EndDate=this.pipe.transform(this.InsertUpdateSubjectResource.EndDate,'MM/dd/yyyy');
      this.InsertUpdateSubjectResource.SubjectRoleAssignmentId=this.SubjectRoleID.Subject_Role_Assignment_ID;
      this.InsertUpdateSubjectResource.languageTypeCode=null;
      this.InsertUpdateSubjectResource.RoleAssignmentStatusTypeCode=this.SubjectRoleID.Role_Assignment_Status_Type_Code;

      let UDTTerminationReason: any=[];
     

      this.TerminationReasons=this.ResponseReason.filter((item: { Termination_Reason_Selected_Ind: string; }) => item.Termination_Reason_Selected_Ind=="Y");
      this.TerminationReasons.forEach((element: { Subject_Role_Assignment_Id: any; Termination_Reason_Type_Code: any; }) => {
      let list: any = {};
      list["SubjectRoleAssignmentId"] = element.Subject_Role_Assignment_Id;
      list["TerminationReasonTypeCode"] = element.Termination_Reason_Type_Code;
      UDTTerminationReason.push(list);
       });
      // for (let i = 0; i < this.TerminationReasons.length; i++) {
      //   let list: any = {};
      // list["SubjectRoleAssignmentId"] = this.TerminationReasons[i].Subject_Role_Assignment_Id;
      // list["TerminationReasonTypeCode"] = this.TerminationReasons[i].Termination_Reason_Type_Code;
      // UDTTerminationReason.push(list);
      // }
       this.InsertUpdateSubjectResource.UDTSubjectRoleTerminationReason=UDTTerminationReason;
    
    this.service.CreateOrRemoveSubjectRoleAssignment(this.InsertUpdateSubjectResource).subscribe((i:any)=>{
      this.Removeresponse=i;
      if(this.Removeresponse.Message=="Success")
      {
          this.toastr.success("Remove Resource Successfully");
          this.cancelRemoveResourcePopup.emit(this.removeresourcemodal)
      }
      else
      {
      this.toastr.error(this.Removeresponse.Message);
      if(this.RemoveResouceclosepopupflag){
      this.RemoveResouceclosepop();
      }
      }
//  }
//  ).catch((e:any)=>{
//    this.Removeresponse=e;
//    this.toastr.error(this.Removeresponse.statusText);
//    if(this.RemoveResouceclosepopupflag){
//    this.RemoveResouceclosepop();
//    }
//  }
//  )
//     }

  //}
}, (error:any) => { 
  this.Removeresponse=error;
   this.toastr.error(this.Removeresponse.statusText);
   if(this.RemoveResouceclosepopupflag){
   this.RemoveResouceclosepop();
   }
console.log(error) }
);
    }}}


  eventCheck(data:any){
   for (let item of this.ResponseReason) {
     if(item.Termination_Reason_Type_Code==data.value)
     {
        if (item.Termination_Reason_Selected_Ind=="Y") {
            item.Termination_Reason_Selected_Ind="N";
        }
        else{
          item.Termination_Reason_Selected_Ind="Y";
        }
     }
   }
  //this.check=false;
  this.checkboxvalidation();
  this.Editformvalidation();
  
}

Descriptionvaluelength:any;
 DescriptionMaxlength:any;
 Terminationcount(){
  this.DescriptionMaxlength=4000;
  if(this.RemoveResourceAssignform.controls.TerminationCommentText.value!=''&&this.RemoveResourceAssignform.controls.TerminationCommentText.value!=null){
    if(this.RemoveResourceAssignform.controls.TerminationCommentText.value.length>0){
        this.Descriptionvaluelength =this.RemoveResourceAssignform.controls.TerminationCommentText.value.length;
    }
    else{
      this.Descriptionvaluelength=0;
    }
  }
  else{
    this.Descriptionvaluelength=0;
    
  }
 }

 Refresh:any;
 Editformvalidation()
 {
   this.Terminationcount();
   this.Refresh = {
    check:this.check,
    RemoveResourceAssignform:this.RemoveResourceAssignform,
          }

   this.DisableButton1.emit(this.Refresh);
  //  var PowerUserRoleTypeCode = this.ResourceAssignform.get("PowerUserRoleTypeCode").value;
  //  var StartDate = this.ResourceAssignform.get("StartDate").value;
  //  var EndDate = this.ResourceAssignform.get("EndDate").value;
  //  var AssignmentCommentText = this.ResourceAssignform.get("AssignmentCommentText").value;
  //  var PowerUserId = this.ResourceAssignform.get("PowerUserId").value;
  //  if(this.EditResourcePopup){
  //  if(PowerUserRoleTypeCode!=this.SubjectRoleID.Power_User_Role_Type_Code)
  //  this.EditResourceflag=true;
  //  else if(StartDate!=this.SubjectRoleID.Start_Date)
  //  this.EditResourceflag=true;
  //  else if(EndDate!=this.SubjectRoleID.End_Date)
  //  this.EditResourceflag=true;
  //  else if(AssignmentCommentText!=this.SubjectRoleID.Assignment_Comment_Text)
  //  this.EditResourceflag=true;
  // //  else if(PowerUserId!=this.getresourcedetails.Full_Name)
  // //  this.EditResourceflag=true;
  //  else
  //  this.EditResourceflag=false;
   }

   RemoveResourceclosePopup:boolean;
   RemoveResouceclosepop(){
    this.cancelpopup.emit(this.RemoveResourceclosePopup);
   }

   eventCheck1(data:any){
    this.eventCheck(data.target)
   }

}
interface UDTTerminationReason{
  SubjectRoleAssignmentId:any;
  TerminationReasonTypeCode:any;
}
